module.exports = __webpack_public_path__ + "static/media/lu_descanso.9cc5b13b.png";